import React, { useEffect, useState } from 'react'
import '../../login.css'
import axios from 'axios';
import { Link } from 'react-router-dom'
import tmsLogoDark from '../../img/TMS LOGO DARK.svg'
import shypvLogoWhite from '../../img/Shypv Logo SVG White.svg'

export default function Login() {
  const [logindata, setlogindata] = useState({
    email:'',
    password:''
  })

  const headers = {
    'Content-Type': 'application/json'
  }
  const [msg, setmsg] = useState('')
  const API_URL = process.env.REACT_APP_API_URL;
  const APP_VERSION = process.env.REACT_APP_VERSION || '1.1.0';
  const API_PATH = `${API_URL}shypvdriverapp/personnel/login`;
  const features = [
    {
      icon: 'fa-shield-halved',
      title: 'Session Security',
      description: 'Your session expires after 12 hours. Multiple browser tabs share the same session for security.'
    },
    {
      icon: 'fa-upload',
      title: 'Bulk Upload',
      description: 'Upload multiple orders at once with CSV bulk import for faster processing.'
    },
    {
      icon: 'fa-plus-circle',
      title: 'New Medical Order',
      description: 'Create and manage medical delivery orders with specialized handling.'
    },
    {
      icon: 'fa-print',
      title: 'Bulk Print via API',
      description: 'Print multiple labels simultaneously through integrated API system.'
    },
    {
      icon: 'fa-history',
      title: 'Run Sheet Bulk History',
      description: 'View complete history for medical and normal task runsheets.'
    }
  ];
  const [activeFeature, setActiveFeature] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % features.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('usertoken');
    if (token) {
      if (!sessionStorage.getItem('usertoken')) {
        sessionStorage.setItem('usertoken', token);
        sessionStorage.setItem('userid', localStorage.getItem('userid') || '');
        sessionStorage.setItem('user_name', localStorage.getItem('user_name') || '');
        sessionStorage.setItem('username', localStorage.getItem('username') || '');
        sessionStorage.setItem('name', localStorage.getItem('name') || '');
        sessionStorage.setItem('useremail', localStorage.getItem('useremail') || '');
        sessionStorage.setItem('role', localStorage.getItem('role') || '');
        sessionStorage.setItem('branch', localStorage.getItem('branch') || '');
      }
      window.location.replace('/dashboard');
    }
  }, []);

  function persistSession(data){
    const personnel = data?.personnelDTO || {};
    const token = data?.auth?.token || '';
    const userName = personnel.personnel_name || '';
    const userEmail = personnel.email || '';
    const userId = personnel.personnel_id || '';
    const role = personnel.role || '';
    const branch = data?.branch || '';
    const loginTimestamp = Date.now().toString();

    sessionStorage.setItem('user_name', userName);
    sessionStorage.setItem('username', userName);
    sessionStorage.setItem('name', userName);
    sessionStorage.setItem('useremail', userEmail);
    sessionStorage.setItem('userid', userId);
    sessionStorage.setItem('role', role);
    sessionStorage.setItem('branch', branch);
    sessionStorage.setItem('usertoken', token);
    sessionStorage.setItem('loginTimestamp', loginTimestamp);

    localStorage.setItem('user_name', userName);
    localStorage.setItem('username', userName);
    localStorage.setItem('name', userName);
    localStorage.setItem('useremail', userEmail);
    localStorage.setItem('userid', userId);
    localStorage.setItem('role', role);
    localStorage.setItem('branch', branch);
    localStorage.setItem('usertoken', token);
    localStorage.setItem('loginTimestamp', loginTimestamp);
  }

  function Submitlogin(e){
    if (e) {
      e.preventDefault();
    }
    setIsLoading(true);
    setmsg('');
    axios({
      method:'post',
      url:`${API_PATH}`,
      data:logindata,
      headers: headers
    }).then((res)=>{
      if(res.data.success==true){
        persistSession(res.data.data)
        setmsg(res.data.message)
        window.location.replace('/dashboard')
      }else{
        console.log(res.data.errors)
        setmsg(res.data.errors[0].errorMessage)
        setIsLoading(false);
      }
    }).catch((err)=>{
      console.log(err)
      setmsg('Login failed. Please try again.');
      setIsLoading(false);
    })
  }

  // New form styles matching the screenshot
  const formStyles = {
    iconWrapper: {
      width: '64px',
      height: '64px',
      backgroundColor: '#f3f4f6',
      borderRadius: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 24px auto',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    },
    icon: {
      fontSize: '24px',
      color: '#1f2937',
    },
    title: {
      fontSize: '24px',
      fontWeight: '600',
      color: '#111827',
      margin: '0 0 8px 0',
      textAlign: 'center',
    },
    subtitle: {
      fontSize: '14px',
      color: '#6b7280',
      margin: '0 0 32px 0',
      lineHeight: '1.5',
      textAlign: 'center',
    },
    inputGroup: {
      position: 'relative',
      marginBottom: '16px',
    },
    inputIcon: {
      position: 'absolute',
      left: '16px',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#9ca3af',
      fontSize: '16px',
      pointerEvents: 'none',
    },
    input: {
      width: '100%',
      padding: '16px 16px 16px 48px',
      fontSize: '15px',
      border: 'none',
      borderRadius: '14px',
      backgroundColor: '#f3f4f6',
      color: '#111827',
      outline: 'none',
      boxSizing: 'border-box',
      transition: 'all 0.2s ease',
    },
    eyeButton: {
      position: 'absolute',
      right: '14px',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: '#9ca3af',
      padding: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    forgotPassword: {
      textAlign: 'right',
      marginBottom: '24px',
    },
    forgotLink: {
      fontSize: '13px',
      color: '#6b7280',
      textDecoration: 'none',
      cursor: 'pointer',
    },
    submitButton: {
      width: '100%',
      padding: '16px 24px',
      fontSize: '16px',
      fontWeight: '600',
      color: '#ffffff',
      backgroundColor: '#1f2937',
      border: 'none',
      borderRadius: '14px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    message: {
      marginTop: '16px',
      padding: '12px',
      borderRadius: '8px',
      backgroundColor: '#fef2f2',
      color: '#dc2626',
      fontSize: '13px',
      textAlign: 'center',
    },
  };

  return (
    <div className="login-page">
      <title>Login - Shypv Dashboard</title>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css" />  
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />  
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <style>
        {`
          .new-form-input::placeholder {
            color: #9ca3af;
          }
          .new-form-input:focus {
            background-color: #ffffff !important;
            box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
          }
          .login-btn {
            transition: all 0.3s ease !important;
          }
          .login-btn:hover:not(:disabled) {
            background-color: #374151 !important;
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(31, 41, 55, 0.3);
          }
          .login-btn:active:not(:disabled) {
            transform: translateY(0);
          }
          .login-btn:disabled {
            opacity: 0.7;
            cursor: not-allowed;
          }
          .login-btn .spinner {
            display: inline-block;
            width: 18px;
            height: 18px;
            border: 2px solid rgba(255,255,255,0.3);
            border-radius: 50%;
            border-top-color: #fff;
            animation: spin 0.8s ease-in-out infinite;
            margin-right: 8px;
            vertical-align: middle;
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          .login-right-panel {
            flex: 1;
            background: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 40px;
            min-height: 100%;
          }
          .form-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 32px;
            width: 100%;
            max-width: 380px;
          }
          .logo-above-form {
            height: 40px;
            width: auto;
          }
          .error-card {
            background-color: #fef2f2;
            border: 1px solid #fecaca;
            border-radius: 12px;
            padding: 12px 16px;
            margin-top: 16px;
            display: flex;
            align-items: center;
            gap: 10px;
            animation: shakeError 0.4s ease-in-out;
          }
          .error-card i {
            color: #dc2626;
            font-size: 16px;
          }
          .error-card span {
            color: #b91c1c;
            font-size: 13px;
            font-weight: 500;
          }
          @keyframes shakeError {
            0%, 100% { transform: translateX(0); }
            25% { transform: translateX(-5px); }
            75% { transform: translateX(5px); }
          }
        `}
      </style>
      <div className="login-shell">
        {/* Left side - Features panel (keeping original) */}
        <div className="login-visual">
          <div className="login-visual-content" style={{display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
            <div style={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
              <span className="login-eyebrow" style={{fontWeight: '700', fontSize: '16px', letterSpacing: '2px'}}>TMS UPDATES</span>
              <div className="login-feature" style={{textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <div className="login-feature-icon" style={{marginBottom: '16px'}}>
                  <i className={`fa ${features[activeFeature].icon}`} aria-hidden="true" />
                </div>
                <div style={{textAlign: 'center'}}>
                  <h2 style={{textAlign: 'center'}}>{features[activeFeature].title}</h2>
                  <p style={{textAlign: 'center'}}>{features[activeFeature].description}</p>
                </div>
              </div>
              <div className="login-progress">
                {features.map((_, index) => (
                  <span
                    key={index}
                    className={index === activeFeature ? 'login-dot active' : 'login-dot'}
                  />
                ))}
              </div>
            </div>
            <div style={{textAlign: 'center', paddingBottom: '30px'}}>
              <div style={{fontSize: '13px', color: 'rgba(255,255,255,0.7)', marginBottom: '12px'}}>
                Version <strong style={{fontWeight: '700'}}>{APP_VERSION}</strong>
              </div>
              <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'}}>
                <span style={{fontSize: '13px', color: 'rgba(255,255,255,0.7)'}}>Powered by</span>
                <img src={shypvLogoWhite} alt="Shypv" style={{height: '20px', width: 'auto'}} />
              </div>
            </div>
          </div>
        </div>
        
        {/* Right side - Clean gradient background with form */}
        <div className="login-right-panel">
          <div className="form-wrapper">
            {/* TMS Logo above form */}
            <img src={tmsLogoDark} alt="TMS" className="logo-above-form" style={{height: '50px', width: 'auto'}} />
            
            {/* Icon */}
            <div style={formStyles.iconWrapper}>
              <i className="fa-solid fa-arrow-right-to-bracket" style={formStyles.icon}></i>
            </div>
            
            {/* Title */}
            <div style={{textAlign: 'center', marginTop: '-16px'}}>
              <h1 style={formStyles.title}>Sign in with email</h1>
              <p style={formStyles.subtitle}>
                Make a new doc to bring your words, data,<br />
                and teams together. For free
              </p>
            </div>
            
            {/* Form */}
            <form onSubmit={Submitlogin} style={{width: '100%'}}>
              {/* Email Input */}
              <div style={formStyles.inputGroup}>
                <i className="fa-regular fa-user" style={formStyles.inputIcon}></i>
                <input
                  type="email"
                  placeholder="Email"
                  className="new-form-input"
                  value={logindata.email}
                  onChange={(e) => setlogindata({...logindata, email: e.target.value})}
                  style={formStyles.input}
                  required
                />
              </div>
              
              {/* Password Input */}
              <div style={formStyles.inputGroup}>
                <i className="fa-solid fa-lock" style={formStyles.inputIcon}></i>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Password"
                  className="new-form-input"
                  value={logindata.password}
                  onChange={(e) => setlogindata({...logindata, password: e.target.value})}
                  style={{...formStyles.input, paddingRight: '44px'}}
                  required
                />
                <button
                  type="button"
                  style={formStyles.eyeButton}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={showPassword ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'} style={{fontSize: '15px'}}></i>
                </button>
              </div>

              {/* Forgot Password */}
              <div style={formStyles.forgotPassword}>
                <Link to="/forgot-password" style={formStyles.forgotLink}>
                  Forgot password?
                </Link>
              </div>

              {/* Submit Button */}
              <button 
                type="submit" 
                className="login-btn" 
                style={formStyles.submitButton}
                disabled={isLoading}
              >
                {isLoading ? (
                  <><span className="spinner"></span>Logging in...</>
                ) : (
                  'Login'
                )}
              </button>
              
              {/* Error Message */}
              {msg && (
                <div className="error-card">
                  <i className="fa-solid fa-circle-exclamation"></i>
                  <span>{msg}</span>
                </div>
              )}
            </form>
            
            {/* Sign Up */}
            <div style={{textAlign: 'center', marginTop: '16px'}}>
              <p style={{fontSize: '13px', color: '#6b7280', margin: 0}}>
                Want to sign up in TMS?{' '}
                <a
                  href="https://shiper.io/"
                  target="_blank"
                  rel="noreferrer"
                  style={{color: '#4f46e5', fontWeight: '600', textDecoration: 'none'}}
                >
                  Click here to contact us
                </a>
              </p>
            </div>

            {/* API Documentation Card */}
            <Link
              to="/api-documentation"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                width: '100%',
                marginTop: '8px',
                padding: '16px 18px',
                background: 'linear-gradient(135deg, #f0fbff 0%, #ffffff 100%)',
                border: '1px solid #bae0f3',
                borderRadius: '14px',
                textDecoration: 'none',
                color: '#1f2937',
                transition: 'all 0.2s ease',
                boxSizing: 'border-box',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,166,237,0.15)';
                e.currentTarget.style.borderColor = '#00a6ed';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = '#bae0f3';
              }}
            >
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '10px',
                  background: 'linear-gradient(135deg, #00a6ed 0%, #0086c0 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <i className="fa-solid fa-code" style={{color: '#fff', fontSize: '18px'}}></i>
              </div>
              <div style={{flex: 1, textAlign: 'left'}}>
                <div style={{fontWeight: 700, fontSize: '14px', color: '#1f2937', marginBottom: '2px'}}>
                  API Documentation
                </div>
                <div style={{fontSize: '12px', color: '#6b7280', lineHeight: 1.4}}>
                  Interactive TMS integration docs — try the APIs live
                </div>
              </div>
              <i className="fa-solid fa-arrow-right" style={{color: '#00a6ed', fontSize: '14px'}}></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
